module.exports = __webpack_public_path__ + "img/loading-logo.e6d6ea0.svg";